import { cn } from '@/lib/utils'

export type SidebarNavExpandPanelProps = {
  open: boolean
  children: React.ReactNode
  /** Extra left inset for workspace-level children block */
  inset?: 'workspace'
}

/** Collapsible panel wrapper (ws-nav-expand-panel grid collapse). */
export function SidebarNavExpandPanel({ open, children, inset }: SidebarNavExpandPanelProps) {
  return (
    <div
      className={cn(
        'ws-nav-expand-panel',
        open && 'ws-nav-expand-panel--open',
        inset === 'workspace' && 'ws-nav-expand-panel--workspace',
      )}
      style={{ gridTemplateRows: open ? '1fr' : '0fr' }}
    >
      <div className="ws-nav-expand-panel__inner">{children}</div>
    </div>
  )
}

/** @deprecated Use SidebarNavExpandPanel */
export const NavExpandPanel = SidebarNavExpandPanel
